import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { useHistory } from 'react-router-dom';
import { buildClientLink } from 'Views/Page/Content/Templates';
import Content from './Content';
import metaOverrideSet from './MetaOverrideSet';

const styles = () => ({
  root: {},
});

const RiskToleranceResultTemplate = ({
  className,
  classes,
  resource,
}) => {
  const history = useHistory();
  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Content}
      onNext={resource.withRelationship(
        fr.relationships.goto.name,
        (rel) => () => history.push(buildClientLink(rel.link('related'))),
        () => undefined,
      )}
    />
  );
};

RiskToleranceResultTemplate.defaultProps = {
  className: '',
};

RiskToleranceResultTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(RiskToleranceResultTemplate);
